import { render, staticRenderFns } from "./SingleComment.vue?vue&type=template&id=4c4b8735&scoped=true&"
import script from "./SingleComment.vue?vue&type=script&lang=js&"
export * from "./SingleComment.vue?vue&type=script&lang=js&"
import style0 from "./SingleComment.vue?vue&type=style&index=0&id=4c4b8735&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4b8735",
  null
  
)

export default component.exports